module.exports = __webpack_public_path__ + "static/media/DEXE-BUSD.55f2300b.svg";